export enum LocalStorageKey {
  ReferringUrl = 'referringUrl',
  SelectedMerchant = 'selectedMerchantId',
  IdMatrixCount = 'idMtrxCnt',
}
